import { render, staticRenderFns } from "./CardFilter.vue?vue&type=template&id=52ab3041"
import script from "./CardFilter.vue?vue&type=script&lang=js"
export * from "./CardFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports